// PEDIR LA LLAMADA DESDE EL TEST DE NIVEL, CON SESIÓN (11-10-2026).
//
// En el resultado del test, «Agendar una llamada» no hacía nada a quien ya había entrado: el
// formulario del test solo se pinta sin sesión. Quien tiene cuenta ya pide la llamada en la
// pantalla de planes (nombre, teléfono y franja, con el correo de su sesión), así que el
// test le lleva allí con ese formulario abierto en vez de tener otro. El test deja dicho
// `llamada: true` junto al resultado (sessionStorage) y aquí se decide para qué plan se abre.
//
// `resultado` es lo que dejó el test; `planes`, el catálogo de la pantalla de planes (por
// código); `actual`, el plan que ya tiene. Devuelve `{ code, name }` o null si no hay que
// abrir nada: no pidió llamada, o es el plan que ya tiene (ese no se le vende otra vez).
export const planDeLaLlamada = (resultado, planes, actual) => {
    if (!resultado?.llamada || !resultado.plan) return null;
    if (actual && actual === resultado.plan) return null;
    const delCatalogo = (planes || {})[resultado.plan];
    return { code: resultado.plan, name: delCatalogo?.name || resultado.nombre || null };
};
